import React from 'react';
import useNestedApps from './useNestedApps';
import { FeatureLoader } from 'oasis-os-react';
/**
 * Automatically load Feature Apps from the parent App's data
 */
const Spawn = ({ featuresField = 'features', sharedModule = './App', hydrate = false, }) => {
    const features = useNestedApps(featuresField);
    return (React.createElement(React.Fragment, null, features.map(({ name, meta, entry }, idx) => (React.createElement(FeatureLoader, { key: `${meta.contentId}_${idx}`, name: name, version: meta.version || meta.appVersion, app: { name }, id: meta.contentId, initial: entry, sharedModule: meta?.sharedModules ? meta?.sharedModules : sharedModule, hydrate: hydrate, ...meta })))));
};
export default Spawn;
